import { render } from "./AlbumDetail.vue?vue&type=template&id=6021a5e3&scoped=true"
import script from "./AlbumDetail.vue?vue&type=script&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&lang=js"

import "./AlbumDetail.vue?vue&type=style&index=0&id=6021a5e3&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6021a5e3"]])

export default __exports__